export const buildUrl = (url, params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null)

  if (entries.length < 1) {
    return url
  }

  const query = entries
    .flatMap(([key, value]) => {
      const values = Array.isArray(value) ? value : [value]

      return values.map((item) => `${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`)
    })
    .join('&')

  return `${url}?${query}`
}
